import { render } from "./ShieldCheck.vue?vue&type=template&id=85be3426"
import script from "./ShieldCheck.vue?vue&type=script&lang=js"
export * from "./ShieldCheck.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "85be3426"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('85be3426', script)) {
    api.reload('85be3426', script)
  }
  
  module.hot.accept("./ShieldCheck.vue?vue&type=template&id=85be3426", () => {
    api.rerender('85be3426', render)
  })

}

script.__file = "src/icons/components/filled/ShieldCheck.vue"

export default script